// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__25iA6","label":"LabeledBox_label__2QHsk"};